import React from 'react';
import {Box, TextField, IconButton, InputAdornment} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface KKMFiltersProps {
    filters: {
        merchantSearch: string;
        kkmSearch: string;
    };
    setFilters: React.Dispatch<
        React.SetStateAction<{
            merchantSearch: string;
            kkmSearch: string;
        }>
    >;
}

const KKMFilters = ({filters, setFilters}: KKMFiltersProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setFilters(prev => ({...prev, [name]: value}));
    };

    const clearField = (field: 'merchantSearch' | 'kkmSearch') => {
        setFilters(prev => ({...prev, [field]: ''}));
    };

    const renderClearAdornment = (field: 'merchantSearch' | 'kkmSearch', value: string) => (
        <InputAdornment position="end">
            {value ? (
                <IconButton size="small" onClick={() => clearField(field)}>
                    <ClearIcon fontSize="small" />
                </IconButton>
            ) : (
                <Box width="32px" /> // резерв под иконку
            )}
        </InputAdornment>
    );

    return (
        <Box display="flex" gap={2} alignItems="center">
            <TextField
                label="Поиск по мерчантам"
                name="merchantSearch"
                value={filters.merchantSearch}
                onChange={handleChange}
                size="small"
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: '44px'
                    }
                }}
                InputProps={{
                    endAdornment: renderClearAdornment('merchantSearch', filters.merchantSearch),
                }}
            />
            <TextField
                label="Поиск по кассам"
                name="kkmSearch"
                value={filters.kkmSearch}
                onChange={handleChange}
                size="small"
                sx={{
                    '& .MuiOutlinedInput-root': {
                        height: '44px'
                    }
                }}
                InputProps={{
                    endAdornment: renderClearAdornment('kkmSearch', filters.kkmSearch),
                }}
            />
        </Box>
    );
};

export default KKMFilters;
